import { useEffect } from 'react';

/**
 * Injects one deduped `<link rel="stylesheet">` per href into `target`'s head
 * (the preview frame's page, or the editor's own for its font suggestions) —
 * parity with what the generated embed snippet does for a customer's page, so
 * the operator's preview shows exactly what they will ship. See
 * `fontLinkLines` in `utils.ts` for the snippet-side counterpart.
 */
export const useFontLinks = (
    hrefs: string[],
    // null while the preview frame has not loaded yet.
    target: Document | null = document
): void => {
    useEffect(() => {
        if (!target) return;
        hrefs.forEach((href) => {
            if (
                target.head.querySelector(`link[data-starjack-font="${href}"]`)
            ) {
                return;
            }

            const link = target.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.dataset.starjackFont = href;
            target.head.appendChild(link);
        });
    }, [hrefs, target]);
};
